module.exports = __webpack_public_path__ + "static/dog-with-wag-tag-desktop-f79dcb10de02a29b829df097db4f669a.png";